import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_URL } from "../constant";
import swal from "sweetalert";
import { useParams, useNavigate, Link } from "react-router-dom";
const ResetModal = (props) => {
  // const [loginModalShow, setLoginModalShow] = useState(props.showModal);
  /******************pass & Cpass************************** */
  const [passData, setPassData] = useState();
  const [cpassData, setCpassData] = useState();
  /********************************************************** */
  const navigat = useNavigate();
  const submitUser = async (events) => {

    events.preventDefault();
    if (validate(events)) {
      const data = new FormData(events.target);

      let formData = {

        'record_id': data.get('record_id'),
        'qty': data.get('qty'),
        'invUsrId': data.get('invUsrId'),
        'itmId': data.get('itmId')

      };

      //console.log(formData); 

      const regDatas = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      }

      const getResps = await fetch(API_URL + 'admin/updateInventoryAssignItem', regDatas);
      const getDatas = await getResps.json();

      swal(getDatas.msg);
      window.location.reload();

    }
  }


  /***************validation**************************** */
  let validate = (ev) => {
    const data = new FormData(ev.target);
    // console.log(data.get);
    let validat = true;

    if (data.get('qty') == '') {
      swal('Please enter quantity');
      return validat = false;
    } else {   //console.log(parseInt((data.get('avQty')))); console.log(parseInt((data.get('qty'))));console.log(parseInt((data.get('reqData'))));
      if (parseInt((data.get('avQty'))) >= data.get('qty')) {
        if (data.get('qty') <= parseInt(data.get('reqData'))) {
          validat = true;
        } else {
          swal('Please enter less than  or equal to requested quantity');
          return validat = false;
        }

      } else {
        swal('Please enter less than  or equal to avaliable quantity');
        return validat = false;
      }

    }

    return validat;
  }

  const mainPage = () => {
    window.location.reload();
    // return navigat('/view_item_list');

  }


  // console.log("PROPS in MODAL", props);
  return (
    <>
      <Modal
        show={props.show}
        cancel={props.close}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header closeButton onClick={props.close} >
          <Modal.Title id="contained-modal-title-vcenter">Assign Inventory Item </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4></h4>
          <form className="form-sample" onSubmit={submitUser}>
            <div className="row">

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-12">Available Quantity *</label>
                  <div className="col-sm-12">
                    {props.avdata}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-12">Quantity *</label>
                  <div className="col-sm-12">
                    <input type="hidden" name="reqData" value={props.reqData} required />
                    <input type="hidden" name="avQty" value={props.avdata} required />
                    <input type="hidden" name="record_id" value={props.data} required />
                    <input type="hidden" name="invUsrId" value={props.usrId} required />
                    <input type="hidden" name="itmId" value={props.itmId} required />
                    <input type="number" min="0" className="form-control" id="exampleInputPassword1" name="qty" placeholder="Quantity" required />
                  </div>
                </div>
              </div>

            </div>
            <button type="submit" className="btn btn-primary mr-2">Submit</button>
            <button type="button" onClick={props.close} className="btn btn-primary mr-2">Cancel</button>
            {/* <button type="button" onClick={()=>{mainPage();props.close();}} className="btn btn-primary mr-2">Cancel</button>  */}
          </form>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={props.close}>Cancel</Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResetModal;
